<svg viewBox="0 0 960 540" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
    class="min-h-screen min-w-screen fixed left-0" style="bottom:-10rem" preserveAspectRatio="none">
    <rect x="0" y="0" width="960" height="540" fill="var(--surface-ground)"></rect>
    <path
        d="M0 331L26.7 321C53.3 311 106.7 291 160 291C213.3 291 266.7 311 320 329.5C373.3 348 426.7 365 480 373.2C533.3 381.3 586.7 380.7 640 373.8C693.3 367 746.7 354 800 341.2C853.3 328.3 906.7 315.7 933.3 309.3L960 303L960 541L933.3 541C906.7 541 853.3 541 800 541C746.7 541 693.3 541 640 541C586.7 541 533.3 541 480 541C426.7 541 373.3 541 320 541C266.7 541 213.3 541 160 541C106.7 541 53.3 541 26.7 541L0 541Z"
        fill="var(--purple-500)" stroke-linecap="round" stroke-linejoin="miter"></path>
</svg>

<div class="grid justify-content-center min-h-screen px-5 text-center bg-gray-100 align-items-center">
    <div class="col-12 md:col-8 lg:col-6 max-w-2xl">
        <div class="card mb-0 bg-white rounded-2xl shadow-md p-8 w-full text-center relative"
            style="border-bottom-left-radius: 0; border-bottom-right-radius: 0;">

            <div class="col-12 px-0 py-4 flex justify-content-center align-items-center gap-2">
                <img src="./assets/favicon.svg" style="max-width: 50px;" class="w-12 h-12" alt="Slicksell Logo">
                <span class="text-3xl font-bold text-gray-500">+</span>
                <img src="assets/youtube-color.svg" style="max-width: 50px;" class="w-12 h-12" alt="Google">
            </div>

            <ng-container *ngIf="loading; else errorState">
                <h3 class="text-xl font-bold text-900 mb-2">Concluindo integração...</h3>
                <p class="text-600 text-sm">Aguarde enquanto conectamos sua conta do Youtube.</p>
            </ng-container>

            <ng-template #errorState>
                <h3 class="text-xl font-bold text-900 mb-2">Falha na integração</h3>
                <p class="text-600 text-sm">{{ errorMessage }}</p>
                <p class="text-500 text-xs mt-3">Esta janela será fechada automaticamente.</p>
            </ng-template>
        </div>

        <div class="w-full" *ngIf="loading">
            <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
        </div>
    </div>
</div>

<p-toast></p-toast>
